import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import VehicleDetail from "@/pages/VehicleDetail";
import Booking from "@/pages/Booking";
import Checkout from "@/pages/Checkout";
import BookingSuccess from "@/pages/BookingSuccess";
import MyBookings from "@/pages/MyBookings";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import InsurancePolicy from "@/pages/InsurancePolicy";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fleet" element={<Catalog />} />
          <Route path="/vehicle/:id" element={<VehicleDetail />} />
          <Route path="/book/:id" element={<Booking />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          <Route path="/booking-success/:id" element={<BookingSuccess />} />
          <Route path="/my-bookings" element={<MyBookings />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/insurance-policy" element={<InsurancePolicy />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(18, 22, 50, 0.95)",
              color: "#fbf0c4",
              border: "1px solid rgba(212, 165, 42, 0.3)",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
